@file:Suppress("ArrayInDataClass")

package model

data class Result(
        val projects: Array<Project> = arrayOf(),
		val configFailed: Boolean = false,
		val currentUser: String = "", // the email the user logged in to taktik.ci with
		val testRuns: Array<TestRun> = arrayOf(), // of the versions of the projects, on any host, the latest first
)

data class Project(
        val name: String,
		val cloneUrl: String,
        val branches: Array<Branch> = arrayOf(),
        val done: Boolean = false
)

data class Branch(
        val projectName: String,
        val name: String,
        val buildResult: BuildResult,
        val oldBuilds: Array<BuildResult> = arrayOf(),
        val meanSuccessDuration: String,
        val deployments: Array<Deployment> = arrayOf(),
		//val latestVersion: String, // not used currently because we display the version of the builds directly
        val done: Boolean = false
)

// TODO: reproduce '26/11/21 11:14' with our locale from the epoch to get rid of createTime/finishTime, and then remove them from here & backend DTO
data class BuildResult(
        val createTime: String = "",
        val createEpoch: Double = 0.0,
        val finishTime: String = "",
        val finishEpoch: Double = 0.0,
        val logUrl: String = "", 
        val commitSha: String = "",
        val status: String = "", // SUCCESS, FAILURE etc.
        val subStatus: String = "",
		val dockerImageName: String = "", // only known when the backend found the version in the docker push logs
        val version: String = "",
        val errorMessage: String = "",
        val commits: Array<Commit> = arrayOf() // the first one is the most recent one
)

data class Commit(
        var commitId: String = "", // SHA
        var committerName: String = "", // full name, i.e. "Simon Hardy"
        var committerEmail: String = "", // without <> TODO: could use this to email people in case of a failed build...
        var commitDate: String = "",
        var commitMessage: String = "" // it's actually only the subject
)

data class Deployment(
		val release: String = "",
		val fixedTag: String = "",
		val hostNames: Array<String> = arrayOf(),
		val personInCharge: String = "",
		val podStatuses: Array<PodStatus> = arrayOf(),
		val ip: String = "",
		val releaseStatus: String = "",
		val lastTagDeployed: String = "",
		val lastTagSuccessfullyDeployed: String = "",
		val upgradeRequired: Boolean = false,
        val paused: Boolean = false
)

data class PodStatus(
		val namespace: String = "",
        val name: String = "",
        val ready: Boolean = false,
        val state: String = "",
        val restarts: Int = -1,
        val startTime: Double? = 0.0,
		val containerNames: Array<String> = arrayOf() // TODO: could display containerNames instead of pod names, would be more user friendly
)

// A run of the e2e lab of a deployment (flowr-frontend-test/scripts/labServe.ts), see TestRunDisplay in the backend
data class TestRun(
		val hostName: String = "",
		val version: String = "", // the frontend version it ran against
		val id: String = "",
		val status: String = "", // preparing, running, cancelling, passed, failed, cancelled, aborted, error
		val statusDetail: String = "",
		val startTime: String = "",
		val startEpoch: Double = 0.0,
		val endEpoch: Double = 0.0, // 0 while it runs
		val startedBy: String = "",
		val scope: String = "", // what it ran, when not just the whole suite: specs, grep... or the command typed in a terminal
		val partial: Boolean = false, // only some of the tests
		val totals: TestTotals = TestTotals(),
		val devices: Array<TestDevice> = arrayOf(),
		val failures: Array<TestFailure> = arrayOf(), // the first ones
		val failureCount: Int = 0,
		val warnings: Array<String> = arrayOf(), // the first ones
		val warningCount: Int = 0,
		val labVersion: String = "",
		val backendVersion: Int? = null,
		val reportUrl: String = "", // empty if it has none
		val recordUrl: String = "",
		val folderUrl: String = "",
		val logs: Array<TestLog> = arrayOf()
)

data class TestTotals(
		val total: Int = 0,
		val completed: Int = 0,
		val passed: Int = 0,
		val failed: Int = 0,
		val flaky: Int = 0, // passed when retried, not counted in passed
		val skipped: Int = 0
)

data class TestDevice(
		val name: String = "",
		val model: String = "",
		val totals: TestTotals = TestTotals()
)

data class TestFailure(
		val device: String = "",
		val test: String = "",
		val error: String = ""
)

data class TestLog(
		val name: String = "",
		val url: String = ""
)
